import { reduxField } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxField.HR.LEGAL()
export { reducer, actions, saga }
